import { Namespaces } from 'redux/namespaces'

export const InitialisationTypes = {
    SET_TOKEN_CHECKED: `${Namespaces.INITIALISATION}_SET_TOKEN_CHECKED`,
    SET_INITIAL_CHECKS_COMPLETED: `${Namespaces.INITIALISATION}_SET_INITIAL_CHECKS_COMPLETED`,
}
